import React from "react";
import "./header.scss";
import Logo from "../images/SpectrumAcceptanceLogo.svg";
import hamburger from "../images/hamburger-icon.svg";
import Drawer from "@mui/material/Drawer";
import { Link } from "gatsby";

type LinksType = {
  link: string;
  text: string;
}[];

type Props = { links: LinksType; toggleDrawer?: () => void; darkNav?: boolean };

function MobileNav({ links, toggleDrawer }: Props) {
  return (
    <nav className="header__mobile-nav">
      <Link to="/">
        <img src={Logo} alt="" />
      </Link>
      <ul>
        {links.length > 0 &&
          links.map((link) => (
            <li key={link.text}>
              <a href={link.link} onClick={toggleDrawer}>
                {link.text}
              </a>
            </li>
          ))}
      </ul>
    </nav>
  );
}

function Header({ links, darkNav }: Props) {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = () => {
    setDrawerOpen((prevState) => !prevState);
  };

  const headerClass = darkNav ? "header --dark" : "header";

  return (
    <header className={headerClass}>
      <div className="header__container">
        <a href="/">
          <img src={Logo} alt="" />
        </a>
        <nav>
          <ul className="header__nav">
            {links.length > 0 &&
              links.map((link) => (
                <li key={link.text}>
                  <a href={link.link}>{link.text}</a>
                </li>
              ))}
          </ul>
        </nav>
        <button className="header__menu-btn" onClick={toggleDrawer}>
          <img src={hamburger} alt="" />
        </button>
        <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer}>
          <MobileNav links={links} toggleDrawer={toggleDrawer} />
        </Drawer>
      </div>
    </header>
  );
}

export default Header;
